<!--
  ~ Copyright (C) 2020 - present by OpenGamma Inc. and the OpenGamma group of companies
  ~
  ~ Please see distribution for license.
  -->

<span [matTooltip]="value | number: '1.0':'en-US'" matTooltipPosition="right">
  {{ value | boundedShortNumber: value:_decimalPipes }}
</span>
